export const PAYCODE_API_URL =
  process.env.PAYCODE_API_URL ||
  process.env.NEXT_PUBLIC_PAYCODE_API_URL ||
  "https://dev.paycode.com.mx";

export const SUPPORT_URL = process.env.NEXT_PUBLIC_SUPPORT_URL || "";

export const SUPPORT_PATH = "/checkout";

export const PRODUCTION_PAYCODE_API_URL = "https://plataforma.paycode.com.mx";

export const IS_PRODUCTION =
  PAYCODE_API_URL.replace(/\/+$/, "") === PRODUCTION_PAYCODE_API_URL;
